import React from 'react';
import { motion } from 'framer-motion';
import { LightningIcon, BrainIcon } from './Icons';
export function Solution() {
  const pillars = [{
    num: '1',
    title: 'CALMAR TU CUERPO CUANDO HAY DINERO',
    desc: 'Quitas esa tensión automática que aparece cuando piensas en dinero (respiración + liberación física)'
  }, {
    num: '2',
    title: 'REENTRENAR LO QUE TU CEREBRO VE',
    desc: 'Tu mente empieza a detectar oportunidades que antes ignoraba (cambio en tu "filtro mental")'
  }, {
    num: '3',
    title: 'CAMBIAR EL PATRÓN QUE TE SABOTEA',
    desc: 'Dejas de reaccionar igual que siempre (ejercicios guiados que cambian cómo piensas y sientes)'
  }];
  return <section className="bg-secondary py-10 md:py-16 px-4 md:px-12" data-id="element-272">
      <div className="max-w-5xl mx-auto" data-id="element-273">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-12 md:mb-16" data-id="element-274">
          <h2 className="font-playfair font-extrabold text-3xl md:text-5xl text-warm-white mb-6" data-id="element-275">
            Esto es lo que realmente cambia:
          </h2>
          <p className="font-inter text-base md:text-lg text-warm-muted max-w-2xl mx-auto leading-relaxed mb-4" data-id="element-276">
            Este sistema{' '}
            <span className="text-warm-white font-semibold" data-id="element-277">
              reentrena cómo tu cuerpo reacciona al dinero
            </span>
            . No intenta motivarte. Trabaja donde está el problema:
          </p>
          <div className="font-playfair font-bold text-2xl md:text-3xl text-gold mb-8 flex items-center justify-center gap-3" data-id="element-278">
            <LightningIcon className="w-7 h-7 md:w-8 md:h-8" data-id="element-279" /> tu sistema
            nervioso
          </div>
          <p className="font-inter text-base md:text-lg text-warm-white" data-id="element-280">
            Durante 21 días vas a hacer 3 cosas clave:
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-8 mb-12" data-id="element-281">
          {pillars.map((pillar, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: idx * 0.15
        }} className="bg-card rounded-xl p-6 md:p-8 border-t-4 border-gold flex flex-col items-center text-center shadow-lg" data-id="element-282">
              <div className="font-inter font-bold text-4xl text-gold mb-4 flex items-center justify-center gap-2" data-id="element-283">
                <BrainIcon className="w-8 h-8" data-id="element-284" /> {pillar.num}.
              </div>
              <h3 className="font-inter font-bold text-lg md:text-xl text-warm-white mb-3" data-id="element-285">
                {pillar.title}
              </h3>
              <p className="font-inter text-sm md:text-base text-warm-muted leading-relaxed" data-id="element-286">
                {pillar.desc}
              </p>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center" data-id="element-287">
          <p className="font-inter text-lg text-warm-muted mb-2" data-id="element-288">
            No es pensar positivo.
          </p>
          <p className="font-playfair font-bold text-2xl md:text-3xl text-gold" data-id="element-289">
            Es cambiar lo que haces… cuando el dinero aparece.
          </p>
        </motion.div>
      </div>
    </section>;
}